import { Component, OnInit } from '@angular/core';
import { WizardService } from '../wizard/wizard.service';
import { ICol, IWizardCol } from '../wizard/wizard-col.component';
import { IWizardForm } from '../wizard/wizard-form.component';
import { ISession } from '../../../models/session';
import { step0, step1, step1Public, step1Private, step2 } from './step';
import { registrationForm, preRegistrationForm } from '../wizard/registration-form';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { filter, tap } from 'rxjs/operators';
import { ThemeService } from '../../../theme/theme.service';
import * as store from 'store';
import { ThemeDirective } from '../../../theme/theme.directive';
import { eva_constants } from '../../../eva_constants';

@Component({
  templateUrl: './session-create.component.html',
  styleUrls: ['./session-create.component.scss']
})
export class SessionsCreateComponent implements OnInit {
  public privacyLevel: string;
  public accountType: string;
  public sessionType: string;
  public registrationForm: IWizardForm = registrationForm;
  public preRegistrationForm: IWizardForm = preRegistrationForm;
  public session: ISession;
  public step0: IWizardCol = step0;
  public step1: IWizardCol = step1;
  public step1Public: IWizardCol = step1Public;
  public step1Private: IWizardCol = step1Private;
  public step2: IWizardCol = step2[eva_constants.EVA_THEME];
  public registrationFormBuilder: IWizardForm;
  public theme: String = eva_constants.EVA_THEME;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private wizardService: WizardService
  ) {}

  ngOnInit() {
    this.wizardService.privacy$.subscribe(level => (this.privacyLevel = level));
    this.wizardService.accountType$.subscribe(type => {
      if (type === 'free' || type === 'registration') {
        this.wizardService.getPrivacySubscription().next('public');
      } else {
        this.wizardService.getPrivacySubscription().next('private');
      }
      return this.accountType = type;
    });
    this.wizardService.sessionType$.subscribe(type => (this.sessionType = type));
    this.wizardService.session$.subscribe(data => (this.session = data));
    this.wizardService.registrationForm$.subscribe(form => {
      this.registrationFormBuilder = form;
    });

    if (this.route && this.route.data) {
      this.route.data.subscribe(data => {
        this.bindTheme(data);
      });
    }

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        tap(() => {
          if (!this.route.snapshot.firstChild) return;
          const { data } = this.route.snapshot.firstChild;
          this.bindTheme(data);
        })
      )
      .subscribe(null);
  }

  isEVA() {
    return this.theme === eva_constants.EVA_THEME;
  }

  bindTheme(data) {
    if (!data) return;
    if (!data.theme) data.theme = store.get(ThemeDirective.THEME);

    if (data.theme) {
      this.theme = data.theme;
      this.step2 = step2[data.theme];
    }
  }

  toExit(event, val): boolean {
    return val === 1 || event;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/create/session-create.component.ts